import { NoSound } from '@/components/icons/video/no-sound';
import { Sound } from '@/components/icons/video/sound';
import { useVideoStore } from '../hooks/useVideoStore';
import { Button } from './Button';

export function MuteUnmuteButton() {
  const { isMuted, toggleMute } = useVideoStore((state) => ({
    isMuted: state.isMuted,
    toggleMute: state.toggleMute,
  }));

  return (
    <Button
      label={isMuted ? 'UnMute video' : 'Mute video'}
      icon={isMuted ? <NoSound /> : <Sound />}
      onClick={toggleMute}
    />
  );
}
